const NOTIFICATION_ACTION_TYPES = {
  GET_NOTIFICATIONS_START: 'notification/GET_NOTIFICATIONS_START',
  GET_NOTIFICATIONS_SUCCESS: 'notification/GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_FAILED: 'notification/GET_NOTIFICATIONS_FAILED',
  RESET_NOTIFICATIONS: 'notification/RESET_NOTIFICATIONS',
};

export default NOTIFICATION_ACTION_TYPES;
